// extracted by mini-css-extract-plugin
export default {"actionButton":"ImageButtom_actionButton__7g1ng","copy":"ImageButtom_copy__m1MIc","mail":"ImageButtom_mail__Ruy9R","rupee":"ImageButtom_rupee__bVchO"};